// Light/dark theme state. The active theme is the data-theme attribute on
// <html>; the user's explicit choice is persisted in localStorage.
// index.html applies the same logic before first paint.

export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "xq-console-theme";

/** The saved choice, else light. */
export function resolveTheme(): Theme {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch {
    // storage blocked (private mode): fall through
  }
  // Light by default: the OS preference is deliberately not followed
  return "light";
}

/** Apply a theme and remember it as the user's choice. */
export function setTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // choice just won't survive a reload
  }
}
